import { Separator } from 'components/ui/separator';

export const FormsSeparator = () => (
  <Separator className="bg-base-border ml-2 w-[290px]" />
);
